import { DateValidationError } from "@mui/x-date-pickers";
import { useState } from "react";

export type DateError = DateValidationError | "";

export interface DateErrors {
  dateFrom: DateError;
  dateTo: DateError;
}

export const useDatePickerValidation = () => {
  const [error, setError] = useState<DateErrors>({
    dateFrom: "",
    dateTo: "",
  });

  const isValidDate = !error.dateFrom && !error.dateTo;

  return { error, setError, isValidDate };
};

export const useSingleDatePickerValidation = () => {
  const [error, setError] = useState<DateError>("");

  return { error, setError };
};
